/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Server_Busy_ContentInputs */

const en_dialog_server_busy_content = /** @type {(inputs: Dialog_Server_Busy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please try again later.`)
};

const ar_dialog_server_busy_content = /** @type {(inputs: Dialog_Server_Busy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يرجى المحاولة مرة أخرى لاحقًا.`)
};

const de_dialog_server_busy_content = /** @type {(inputs: Dialog_Server_Busy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte versuchen Sie es später noch einmal.`)
};

const es_dialog_server_busy_content = /** @type {(inputs: Dialog_Server_Busy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, inténtalo más tarde.`)
};

const fr_dialog_server_busy_content = /** @type {(inputs: Dialog_Server_Busy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez réessayer ultérieurement.`)
};

const it_dialog_server_busy_content = /** @type {(inputs: Dialog_Server_Busy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova più tardi.`)
};

const ja_dialog_server_busy_content = /** @type {(inputs: Dialog_Server_Busy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`しばらくしてからもう一度お試しください。`)
};

const ko_dialog_server_busy_content = /** @type {(inputs: Dialog_Server_Busy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나중에 다시 시도하세요.`)
};

const pt_br_dialog_server_busy_content = /** @type {(inputs: Dialog_Server_Busy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tente novamente mais tarde.`)
};

const ru_dialog_server_busy_content = /** @type {(inputs: Dialog_Server_Busy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторите попытку позже.`)
};

const th_dialog_server_busy_content = /** @type {(inputs: Dialog_Server_Busy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรดลองอีกครั้งในภายหลัง`)
};

const tr_dialog_server_busy_content = /** @type {(inputs: Dialog_Server_Busy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen daha sonra tekrar dene.`)
};

const zh_cn_dialog_server_busy_content = /** @type {(inputs: Dialog_Server_Busy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请稍后再次尝试`)
};

const zh_tw_dialog_server_busy_content = /** @type {(inputs: Dialog_Server_Busy_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請稍後再次嘗試`)
};

/**
* | output |
* | --- |
* | "Please try again later." |
*
* @param {Dialog_Server_Busy_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_server_busy_content = /** @type {((inputs?: Dialog_Server_Busy_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Server_Busy_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_server_busy_content(inputs)
	if (locale === "ar") return ar_dialog_server_busy_content(inputs)
	if (locale === "de") return de_dialog_server_busy_content(inputs)
	if (locale === "es") return es_dialog_server_busy_content(inputs)
	if (locale === "fr") return fr_dialog_server_busy_content(inputs)
	if (locale === "it") return it_dialog_server_busy_content(inputs)
	if (locale === "ja") return ja_dialog_server_busy_content(inputs)
	if (locale === "ko") return ko_dialog_server_busy_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_server_busy_content(inputs)
	if (locale === "ru") return ru_dialog_server_busy_content(inputs)
	if (locale === "th") return th_dialog_server_busy_content(inputs)
	if (locale === "tr") return tr_dialog_server_busy_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_server_busy_content(inputs)
	return zh_tw_dialog_server_busy_content(inputs)
});